// extracted by mini-css-extract-plugin
module.exports = {"achievement":"_3LG4-","icon":"miylm","iconImg":"_po9V","text":"_8SoDa","title":"_1pWJY","competition":"mANnw"};